export default function FileUploadIcon(props) {
  return (
    <svg
      width="25"
      height="32"
      viewBox="0 0 25 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.3312 5.83576L18.6669 1.17076C17.9125 0.420887 16.8937 -0.000488281 15.8375 -0.000488281H4.5C2.29125 -0.000488281 0.5 1.79014 0.5 3.99951L0.500406 27.9995C0.500406 30.2083 2.29103 31.9995 4.50041 31.9995H20.5C22.7 31.9995 24.5 30.1995 24.5 27.9995V8.66201C24.5 7.60576 24.0812 6.58701 23.3312 5.83576ZM21.5 27.9995C21.5 28.5518 21.0522 28.9995 20.5 28.9995H4.50125C3.949 28.9995 3.50125 28.5518 3.50125 27.9995L3.5 4.00764C3.5 3.45539 3.94775 3.00764 4.5 3.00764H14.5V7.99951C14.5 9.10389 15.3956 9.99951 16.5 9.99951H21.5V27.9995ZM14 13.9433C14 13.1683 13.3313 12.4995 12.5 12.4995C11.6687 12.4995 11 13.1683 11 13.9433V17.4995H7.5C6.67125 17.4995 6 18.1708 6 18.9433C6 19.772 6.67062 20.387 7.5 20.387H11V23.887C11 24.8308 11.6687 25.4995 12.5 25.4995C13.3287 25.4995 14 24.8283 14 24.0558V20.4433H17.5C18.3288 20.4433 19 19.772 19 18.9995C19 18.227 18.3288 17.5558 17.5 17.5558H14V13.9433Z"
        fill="#5A646E"
      />
    </svg>
  )
}
